module.exports = __webpack_public_path__ + "img/panel3.5ab7121c.jpg";